import { useNavigate } from 'react-router-dom'
import { notifications } from '@mantine/notifications'
import EquipamentoForm from './EquipamentoForm'
import { useEquipamentoCreate } from '../../hooks/useEquipamentos'
import { extractApiError } from '../../lib/extractApiError'
import type { EquipamentoFormData } from './schema'
import styles from '../_shared/CrudPage.module.css'

export default function EquipamentoNovoPage() {
  const navigate = useNavigate()
  const create = useEquipamentoCreate()

  async function handleSubmit(data: EquipamentoFormData) {
    try {
      const res = await create.mutateAsync(data)
      notifications.show({ color: 'green', message: 'Equipamento criado com sucesso.' })
      navigate(`/equipamentos`)
      void res
    } catch (err) {
      notifications.show({
        color: 'red',
        title: 'Falha ao criar equipamento',
        message: extractApiError(err, 'Verifique os dados e tente novamente.'),
      })
    }
  }

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div>
          <button
            className={styles.backBtn}
            onClick={() => navigate('/equipamentos')}
            type="button"
          >
            ← Voltar
          </button>
          <h1 className={styles.title}>Novo Equipamento</h1>
        </div>
      </header>
      <EquipamentoForm
        onSubmit={handleSubmit}
        isLoading={create.isPending}
        submitLabel="Criar Equipamento"
      />
    </div>
  )
}
